import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import FlowControlFieldImport from "../../misc/FlowControlFieldImport";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import { setImportedLayoutFields, setImportedLayoutIsFixed } from "../../../actions/flowControlActions";
import withModal from "../withModal";
import { IImportLayoutField } from "../../../types/stores/externalServiceLayoutData";

const fcLayoutImportModalProps = {
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

type FCLayoutImportModalProps = PropTypes.InferProps<typeof fcLayoutImportModalProps>;

const UEFieldSearchModal: React.FC<FCLayoutImportModalProps> = ({ isOpen }: FCLayoutImportModalProps) => {
    const dispatch = useDispatch();
    const [layoutIsFixed, setLayoutIsFixed] = useState(false);

    const [importedFields, setImportedFields] = useState<Array<IImportLayoutField>>([]);

    const hide = () => {
        dispatch(hideModal("FLOW_CONTROL_LAYOUT_IMPORT"));
        setImportedFields([]);
    };

    const importLayout = () => {
        dispatch(setImportedLayoutFields(importedFields));
        dispatch(setImportedLayoutIsFixed(layoutIsFixed));
        setImportedFields([]);
        setLayoutIsFixed(false);
        hide();
    };

    const disableImport =
        !importedFields || importedFields.length == 0 || importedFields.filter(x => !x.IsValid).length > 0;

    return (
        <MaterialModal
            id="import-layouts"
            title="Import Layout"
            maxWidth="lg"
            fullWidth={true}
            isOpen={Boolean(isOpen)}
            onClose={hide}
            cancelButtonText="Close"
            showPrimaryButton={true}
            primaryButtonText="Import"
            onPrimaryButtonRequest={importLayout}
            isPrimaryButtonDisabled={disableImport}
        >
            <div>
                <FlowControlFieldImport
                    importType="layout"
                    excludeErrors={false}
                    excludeErrorsChanged={() => null}
                    importedLayoutFields={importedFields}
                    updateFields={setImportedFields}
                    layoutFixed={layoutIsFixed}
                    setLayoutFixed={setLayoutIsFixed}
                />
            </div>
        </MaterialModal>
    );
};

export default withModal(UEFieldSearchModal, "FLOW_CONTROL_LAYOUT_IMPORT");
